export enum KpiServiceErrorType {
    missingInputParameters,
    noData,
    requestError
}

export class KpiServiceError extends Error {
    public type: KpiServiceErrorType;

    constructor(type: KpiServiceErrorType, message?: string) {
        super(message);
        this.type = type;
    }
}